const Filter: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.66667 17.1429C8.66667 16.6695 9.03976 16.2857 9.5 16.2857H14.5C14.9602 16.2857 15.3333 16.6695 15.3333 17.1429C15.3333 17.6162 14.9602 18 14.5 18H9.5C9.03976 18 8.66667 17.6162 8.66667 17.1429ZM5.33333 12C5.33333 11.5266 5.70643 11.1429 6.16667 11.1429H17.8333C18.2936 11.1429 18.6667 11.5266 18.6667 12C18.6667 12.4734 18.2936 12.8571 17.8333 12.8571H6.16667C5.70643 12.8571 5.33333 12.4734 5.33333 12ZM2 6.85714C2 6.38376 2.3731 6 2.83333 6H21.1667C21.6269 6 22 6.38376 22 6.85714C22 7.33053 21.6269 7.71429 21.1667 7.71429H2.83333C2.3731 7.71429 2 7.33053 2 6.85714Z"
      fill="currentColor"
    />
  </svg>
);

export default Filter;
